import { TextField } from '@material-ui/core';
import I18n from '@/rI18n';
import Utils from '@/common/utils/utils';
import {
    filterLabelByKey,
    filterUnitByKey,
    validateTextField
} from '../../../handler/VersionListHandler';

function BasicSetting({
    value,
    setValue,
    internalQACounterSettings,
    deskService,
    knowledgeService,
    setIsEdit,
    ...props
}) {
    const handleOnChange = (field, e) => {
        let inputValue = e.target.value
        setIsEdit(true)

        setValue(item => {
            return {
                ...item,
                [field[0]]: {
                    ...item[field[0]],
                    value: inputValue,
                    error: ''
                }
            };
        });
    };

    const handleOnBlur = (field, e) => {
        let blurValue =  e.target.value.trim();

        if(Utils.isEmptyString(blurValue)) {
            setValue(item => {
                return {
                    ...item,
                    [field[0]]: {
                        ...item[field[0]],
                        error: I18n.get('COMMSG014')
                    }
                };
            });
            return;
        }

        const checkErrorValueInput = validateTextField(field[1].rules, blurValue, field[0]);
        setValue(item => {
            return {
                ...item,
                [field[0]]: {
                    ...item[field[0]],
                    value: blurValue,
                    error: checkErrorValueInput
                }
            };
        });
    };


    const handleDisabled = item => {
        if (item === 'numberOfQACounters' && !deskService) return true;
        if (item === 'numberOfKnowledges' && !knowledgeService) return true;
        if (item === 'numberOfSupportedCounters' && !deskService) return true;
        if (item === 'numberOfB2C' && !deskService) return true;
        return false;
    };

    return (
        <>
            <div className="setting-description border-bottom">
                <span className="description-detail col-5">上限項目</span>
                <span className="description-detail col-5">上限数</span>
            </div>
            {Object.entries(value).map((item, index) => {
                return (
                    <div className="setting-item border-bottom" key={index}>
                        <label className="setting-label col-5">{filterLabelByKey(item[0])}</label>
                        <div className="setting-action col-5">
                            <TextField
                                className="form-control-input form-control-wrapInput form-control-hg32 setting-input"
                                variant="outlined"
                                spellCheck={false}
                                type="text"
                                value={item[1].value}
                                disabled={handleDisabled(item[0])}
                                onChange={e => handleOnChange(item, e)}
                                onBlur={e => handleOnBlur(item, e)}
                                onWheel={e => e.target.blur()}
                                helperText={item[1].error}
                                error={!Utils.isEmptyString(item[1].error)}
                            />
                            <label className="setting-unit">{filterUnitByKey(item[1].unit)}</label>
                        </div>
                    </div>
                );
            })}
        </>
    );
}

export default BasicSetting;
